function arraysOverlap<T>(first: T[], second: T[]): boolean {
  return first.some((e) => second.includes(e));
}

function arrayContains<T>(first: T[], second: T[]): boolean {
  return second.every((e) => first.includes(e));
}

function areArraysEqual<T>(a: T[], b: T[]): boolean {
  return a.length === b.length && a.every((element, index) => element === b[index]);
}

const userRolesOverlap = arrayContains;

export { arraysOverlap, areArraysEqual, userRolesOverlap, arrayContains };
